import React from 'react';
import styles from './IconTextButton.module.css';

function IconTextButton({ 
  icon,
  text,
  onClick,
  state = 'enabled', // enabled, disabled
  iconPosition = 'left' // left, right
}) {
  return (
    <button
      className={`
        ${styles.iconTextButton} 
        ${styles[state]}
        ${styles[`icon-${iconPosition}`]}
      `}
      onClick={onClick}
      disabled={state === 'disabled'}
    >
      {iconPosition === 'left' && (
        <img 
          src={`/asset/${icon}`} 
          alt=""
          className={styles.icon}
        />
      )}
      <span className={styles.text}>{text}</span>
      {iconPosition === 'right' && (
        <img 
          src={`/asset/${icon}`} 
          alt=""
          className={styles.icon}
        />
      )}
    </button>
  );
}

export default IconTextButton; 